// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dependency-groups h4 {\n  line-height: 1.4;\n}\n\n.dependency-groups h4 > span {\n  border-bottom: 1px solid #d8d8d8;\n  margin-bottom: 3px;\n}\n\n.dependency-group li span {\n  color: #666;\n}", ""]);
// Exports
module.exports = exports;
